"use client";

import * as React from "react";

import { MagnifyingGlassIcon } from "../../components/common/icons";
import { cn } from "@punchup/utils/cn";

export interface SearchInputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <div className="flex relative py-4 w-full">
        <div className="absolute top-1/3 ml-4 mt-0.5 text-gray-500">
          <MagnifyingGlassIcon
            width={20}
            height={20}
            className="stroke-tertiary-blue"
          />
        </div>

        <input
          type={type}
          className={cn(
            "items-center pr-4 appearance-none focus:outline-none text-primary-blue w-full font-sans text-[16px] pl-12 pr-4 py-2 placeholder:font-light placeholder:text-tertiary-blue border border-secondary-blue rounded-[10px]",
            className
          )}
          ref={ref}
          {...props}
        />
      </div>
    );
  }
);

SearchInput.displayName = "SearchInput";

export { SearchInput };
